module.exports = __webpack_public_path__ + "static/media/logo.fdc021e4.svg";